module.exports = __webpack_public_path__ + "static/media/wp.11fdec3f.svg";